import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

Vue.filter('NumberFormat', function (value) {
  if (!value) {
    return '0'
  }
  const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  return intPartFormat
})

Vue.filter('dayjs', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

Vue.filter('moment', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

Vue.filter('filterDict', function (val, opts) {
  if (!val) return
  for (let d of opts) {
    if (d.dictValue == val) {
      return d.dictLabel
    }
  }
})

Vue.filter('keepTwo', function (val) {
  const resVal = (Number(val) / 10000).toFixed(2)
  return resVal
})

Vue.filter('filterlist', function (val, opts) {
  if (!val) return
  for (let d of opts) {
    if (d.leaderId === val) {
      return d.leader
    }
  }
})

Vue.filter('keepTwo_wan', function (val) {
  if (Number(val) > 100) {
    const resVal = (Number(val) / 10000).toFixed(2)
    return resVal + '万元'
  } else {
    return Number(val) + '元'
  }

})